<template>
   <div class="layout-page">
      <h1>Invitations</h1>
      <p>The following invitations were sent to prospects to invite them to join your downline:</p>

      <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
      <div v-else v-cloak>
         <div class="b-card">
            <div class="card-header bg-transparent">
               <router-link :to="{name: 'linx', params: {useLocalStorage: false}}" class="float-right new-inv">
                  <i class="fas fa-plus"></i>
                  New Invitation
               </router-link>
               <i class="fi-creative-users"></i>
               <span class="card-label">Recruitment Invitations</span>
            </div>
            <div class="card-body">
               <div class="font-smaller">
                  <data-grid
                     :headers="headers"
                     :records="records"
                     :rowsPerPage="pageSize"
                     :currentPage="page"
                     :totalRecords="totalRecs"
                     :navHandler="navHandler"
                     :noDataMsg="noDataMsg"
                     @page-size-changed="pageChanged"
                     :clickHandler="gridClickHandler"
                  >
                  </data-grid>
               </div>
            </div>
         </div>

         <div class="custom-control form-control-lg custom-checkbox font-smaller">
            <input type="checkbox" class="custom-control-input" @change="checkChange($event)"
               id="chkHideAppointed" v-model="hideAppointed">
            <label class="custom-control-label" for="chkHideAppointed">Hide Invites for Appointed Agents</label>
         </div>
      </div>
   </div>
</template>

<script>
import DataGrid from "@/components/datagrid.vue";
export default {
   components: {
      "data-grid": DataGrid,
   },
   computed: {
      totalPages() {
         return this.hasData ? Math.trunc(this.totalRecs / this.pageSize) + (this.totalRecs % this.pageSize > 0 ? 1 : 0) : 0
      }
   },
   data() {
      return {
         loading: false,
         records: [],
         pageSize: 10,
         page: 0,
         totalRecs: 0,
         noDataMsg: 'no invitation data found',
         hideAppointed: true,
         headers: [
            {
               name: "inviteDt",
               label: "Invite Date",
               sortable: true,
               isdate: true,
               ismoney: false,
            },
            {
               name: "prospect",
               label: "Prospect",
               sortable: true,
               isdate: false,
               ismoney: false,
            },
            {
               name: "hierarchy",
               label: "Hierarchy",
               sortable: true,
               isdate: false,
               ismoney: false,
            },
            {
               name: "level",
               label: "Level",
               sortable: true,
               isdate: false,
               ismoney: false,
            },
            {
               name: "__ACTION",
               label: "Invitation",
               sortable: true,
               isdate: false,
               ismoney: false,
               tt: 'View past invitation'
            },
            {
               name: "status",
               label: "Status",
               sortable: true,
               isdate: false,
               ismoney: false,
            },
         ],
      };
   },
   async mounted() {
      await this.initialize();
   },
   methods: {
      async initialize() {
         this.$parent.loadingStart()
         await this.fetchData()
         await this.$nextTick()
         this.$parent.loadingEnd()
      },
      async navHandler(command) {
         switch(command) {
               case 'FIRST':
                  this.page = 0
                  break;
               case 'PREVIOUS':
                  this.page--
                  break;
               case 'NEXT':
                  this.page++
                  break;
               case 'LAST':
                  this.page = this.totalPages - 1
                  break;
         }
         this.$parent.loadingStart()
         await this.fetchData()
         await this.$nextTick()
         this.$parent.loadingEnd()
      },
      hasData() {
         if (this.records != null) {
               return this.records.length > 0
         }
         return false
      },
      async pageChanged(newCount) {
         this.page = 0
         this.pageSize = parseInt(newCount)
         
         this.$parent.loadingStart()
         await this.fetchData()
         await this.$nextTick()
         this.$parent.loadingEnd()
      },
      async checkChange() {
         this.$parent.loadingStart()
         this.page = 0 //reset this since differnt qty rows returned when chnged
         await this.fetchData()
         await this.$nextTick()
         this.$parent.loadingEnd()
      },
      async fetchData() {
         let payload = {
            userId: this.$store.getters.appUser.userId,
            page: this.page,
            pageSize: this.pageSize,
            hideAppointed: this.hideAppointed
         }
         await this.$appoint.viewInvitations(payload)
         .then((r) => {
            if (!r || r == false) {
               this.$swal(
                  "Oops!",
                  "Some system error occurred while retriving past invitations. If this problem persists, please contact support.",
                  "error"
               );
               return;
            }

            this.records = r.results
            this.totalRecs = r.totalRecords
            this.buildInviteLinks()
         })
         .catch((err) => {
            // log err
         })
      },
      buildInviteLinks() {
         this.records.forEach((item, index) => {
            if (item.isExternal) {
               item.invitation = "External"
            } else {
               item.invitation = ""
            }
         })
      },
      gridClickHandler(row) {
         if (row.isExternal) {
            this.$swal(
               "Not Available",
               `This invitation was sent from outside of "${process.env.VUE_APP_TITLE}" so we don't have a copy of it. Sorry!`,
               "warning"
            );
         } else {
            this.$router.push({ name: 'invite', params: { existing: row } })
         }
      }
   }
};
</script>

<style scoped>
.new-inv {
   padding-top: 3px;
   font-size: smaller;
}
.card-label {
   margin-left: 6px;
}
</style>